import { render, staticRenderFns } from "./list-manage.vue?vue&type=template&id=375b66c2&scoped=true"
import script from "./list-manage.vue?vue&type=script&lang=ts"
export * from "./list-manage.vue?vue&type=script&lang=ts"
import style0 from "./list-manage.vue?vue&type=style&index=0&id=375b66c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b66c2",
  null
  
)

export default component.exports